import { LANG_OPTIONS } from '@/common/constants/languages';

const PERSONALITY_EN = {
	Vanilla: 'Vanilla',
	Partying: 'Partying',
	Toxic: 'Toxic',
	Guardian: 'Guardian',
	Noble: 'Noble',
	Selfish: 'Selfish',
	Modest: 'Modest',
	Brave: 'Brave',
	Romantic: 'Romantic',
	Sweet: 'Sweet',
	Naughty: 'Naughty',
	Mature: 'Mature',
	Luxury: 'Luxury',
	Fitness: 'Fitness',
	Bossy: 'Bossy',
	Nerdy: 'Nerdy',
};

const OCCUPATION_EN = {
	Student: 'Student',
	Dancer: 'Dancer',
	Model: 'Model',
	Boss: 'Boss',
	Bartender: 'Bartender',
	Engineer: 'Engineer',
	Teacher: 'Teacher',
	'Fitness trainer': 'Fitness trainer',
	Cook: 'Cook',
	Artist: 'Artist',
	Doctor: 'Doctor',
	Librarian: 'Librarian',
	Spy: 'Spy',
	'Police officer': 'Police officer',
	Soldier: 'Soldier',
	Lawyer: 'Lawyer',
	Hairdresser: 'Hairdresser',
	Singer: 'Singer',
	Writer: 'Writer',
	'Flight attendant': 'Flight attendant',
	Athlete: 'Athlete',
	Scientist: 'Scientist',
	Florist: 'Florist',
	Photographer: 'Photographer',
	Designer: 'Designer',
	Pharmacist: 'Pharmacist',
	Dietitian: 'Dietitian',
};

const RELATIONSHIP_EN = {
	Single: 'Single',
	Unknown: 'Unknown',
	Neighbor: 'Neighbor',
	Friend: 'Friend',
	Crush: 'Crush',
	Girlfriend: 'Girlfriend',
	Wife: 'Wife',
	Complicated: 'Complicated',
};

const NATIONALITY_EN = {
	American: 'American',
	British: 'British',
	Polish: 'Polish',
	French: 'French',
	Spanish: 'Spanish',
	Italian: 'Italian',
	German: 'German',
	Ukrainian: 'Ukrainian',
	Brazilian: 'Brazilian',
	Mexican: 'Mexican',
	Japanese: 'Japanese',
	Korean: 'Korean',
	Chinese: 'Chinese',
	Indian: 'Indian',
	Egyptian: 'Egyptian',
	Turkish: 'Turkish',
	Australian: 'Australian',
	Canadian: 'Canadian',
};

const ZODIAC_EN = {
	Aries: 'Aries',
	Taurus: 'Taurus',
	Gemini: 'Gemini',
	Cancer: 'Cancer',
	Leo: 'Leo',
	Virgo: 'Virgo',
	Libra: 'Libra',
	Scorpio: 'Scorpio',
	Sagittarius: 'Sagittarius',
	Capricorn: 'Capricorn',
	Aquarius: 'Aquarius',
	Pisces: 'Pisces',
};

const KINKS_EN = {
	Teasing: 'Teasing',
	Praise: 'Praise',
	Roleplay: 'Roleplay',
	Dominant: 'Dominant',
	Submissive: 'Submissive',
	Voyeur: 'Voyeur',
	Exhibitionist: 'Exhibitionist',
	'Slow burn': 'Slow burn',
};

const VOICE_EN = {
	'Voice 1': 'Voice 1',
	'Voice 2': 'Voice 2',
	'Voice 3': 'Voice 3',
	'Voice 4': 'Voice 4',
	'Voice 5': 'Voice 5',
	'Voice 6': 'Voice 6',
};

export const STUDIO_FINAL_OPTION_LABELS = {
	[LANG_OPTIONS.english]: {
		personality: PERSONALITY_EN,
		occupation: OCCUPATION_EN,
		relationship: RELATIONSHIP_EN,
		nationality: NATIONALITY_EN,
		zodiac: ZODIAC_EN,
		kinks: KINKS_EN,
		voice: VOICE_EN,
	},
	[LANG_OPTIONS.polish]: {
		personality: {
			Vanilla: 'Waniliowa',
			Partying: 'Imprezowa',
			Toxic: 'Toksyczna',
			Guardian: 'Opiekuńcza',
			Noble: 'Szlachetna',
			Selfish: 'Egoistyczna',
			Modest: 'Skromna',
			Brave: 'Odważna',
			Romantic: 'Romantyczna',
			Sweet: 'Słodka',
			Naughty: 'Psotna',
			Mature: 'Dojrzała',
			Luxury: 'Luksusowa',
			Fitness: 'Sportowa',
			Bossy: 'Dominująca',
			Nerdy: 'Kujonka',
		},
		occupation: {
			Student: 'Studentka',
			Dancer: 'Tancerka',
			Model: 'Modelka',
			Boss: 'Szefowa',
			Bartender: 'Barmanka',
			Engineer: 'Inżynierka',
			Teacher: 'Nauczycielka',
			'Fitness trainer': 'Trenerka fitness',
			Cook: 'Kucharka',
			Artist: 'Artystka',
			Doctor: 'Lekarka',
			Librarian: 'Bibliotekarka',
			Spy: 'Szpieg',
			'Police officer': 'Policjantka',
			Soldier: 'Żołnierz',
			Lawyer: 'Prawniczka',
			Hairdresser: 'Fryzjerka',
			Singer: 'Piosenkarka',
			Writer: 'Pisarka',
			'Flight attendant': 'Stewardessa',
			Athlete: 'Sportsmenka',
			Scientist: 'Naukowczyni',
			Florist: 'Florystka',
			Photographer: 'Fotografka',
			Designer: 'Projektantka',
			Pharmacist: 'Farmaceutka',
			Dietitian: 'Dietetyczka',
		},
		relationship: {
			Single: 'Singielka',
			Unknown: 'Nieznana',
			Neighbor: 'Sąsiadka',
			Friend: 'Przyjaciółka',
			Crush: 'Crush',
			Girlfriend: 'Dziewczyna',
			Wife: 'Żona',
			Complicated: 'Skomplikowane',
		},
		nationality: {
			American: 'Amerykanka',
			British: 'Brytyjka',
			Polish: 'Polka',
			French: 'Francuzka',
			Spanish: 'Hiszpanka',
			Italian: 'Włoszka',
			German: 'Niemka',
			Ukrainian: 'Ukrainka',
			Brazilian: 'Brazylijka',
			Mexican: 'Meksykanka',
			Japanese: 'Japonka',
			Korean: 'Koreanka',
			Chinese: 'Chinka',
			Indian: 'Indyjka',
			Egyptian: 'Egipcjanka',
			Turkish: 'Turkini',
			Australian: 'Australijka',
			Canadian: 'Kanadyjka',
		},
		zodiac: {
			Aries: 'Baran',
			Taurus: 'Byk',
			Gemini: 'Bliźnięta',
			Cancer: 'Rak',
			Leo: 'Lew',
			Virgo: 'Panna',
			Libra: 'Waga',
			Scorpio: 'Skorpion',
			Sagittarius: 'Strzelec',
			Capricorn: 'Koziorożec',
			Aquarius: 'Wodnik',
			Pisces: 'Ryby',
		},
		kinks: {
			Teasing: 'Drażnienie',
			Praise: 'Pochwały',
			Roleplay: 'Roleplay',
			Dominant: 'Dominacja',
			Submissive: 'Uległość',
			Voyeur: 'Voyeur',
			Exhibitionist: 'Ekshibicjonizm',
			'Slow burn': 'Powolne narastanie',
		},
		voice: {
			'Voice 1': 'Głos 1',
			'Voice 2': 'Głos 2',
			'Voice 3': 'Głos 3',
			'Voice 4': 'Głos 4',
			'Voice 5': 'Głos 5',
			'Voice 6': 'Głos 6',
		},
	},
	[LANG_OPTIONS.german]: {
		personality: {
			Vanilla: 'Vanille',
			Partying: 'Party',
			Toxic: 'Toxisch',
			Guardian: 'Beschützend',
			Noble: 'Edel',
			Selfish: 'Egoistisch',
			Modest: 'Bescheiden',
			Brave: 'Mutig',
			Romantic: 'Romantisch',
			Sweet: 'Süß',
			Naughty: 'Frech',
			Mature: 'Reif',
			Luxury: 'Luxuriös',
			Fitness: 'Sportlich',
			Bossy: 'Dominant',
			Nerdy: 'Nerdig',
		},
		occupation: {
			Student: 'Studentin',
			Dancer: 'Tänzerin',
			Model: 'Model',
			Boss: 'Chefin',
			Bartender: 'Barkeeperin',
			Engineer: 'Ingenieurin',
			Teacher: 'Lehrerin',
			'Fitness trainer': 'Fitnesstrainerin',
			Cook: 'Köchin',
			Artist: 'Künstlerin',
			Doctor: 'Ärztin',
			Librarian: 'Bibliothekarin',
			Spy: 'Spionin',
			'Police officer': 'Polizistin',
			Soldier: 'Soldatin',
			Lawyer: 'Anwältin',
			Hairdresser: 'Friseurin',
			Singer: 'Sängerin',
			Writer: 'Schriftstellerin',
			'Flight attendant': 'Flugbegleiterin',
			Athlete: 'Sportlerin',
			Scientist: 'Wissenschaftlerin',
			Florist: 'Floristin',
			Photographer: 'Fotografin',
			Designer: 'Designerin',
			Pharmacist: 'Apothekerin',
			Dietitian: 'Ernährungsberaterin',
		},
		relationship: {
			Single: 'Single',
			Unknown: 'Unbekannt',
			Neighbor: 'Nachbarin',
			Friend: 'Freundin',
			Crush: 'Crush',
			Girlfriend: 'Freundin',
			Wife: 'Ehefrau',
			Complicated: 'Kompliziert',
		},
		nationality: {
			American: 'Amerikanerin',
			British: 'Britin',
			Polish: 'Polin',
			French: 'Französin',
			Spanish: 'Spanierin',
			Italian: 'Italienerin',
			German: 'Deutsche',
			Ukrainian: 'Ukrainerin',
			Brazilian: 'Brasilianerin',
			Mexican: 'Mexikanerin',
			Japanese: 'Japanerin',
			Korean: 'Koreanerin',
			Chinese: 'Chinesin',
			Indian: 'Inderin',
			Egyptian: 'Ägypterin',
			Turkish: 'Türkin',
			Australian: 'Australierin',
			Canadian: 'Kanadierin',
		},
		zodiac: {
			Aries: 'Widder',
			Taurus: 'Stier',
			Gemini: 'Zwillinge',
			Cancer: 'Krebs',
			Leo: 'Löwe',
			Virgo: 'Jungfrau',
			Libra: 'Waage',
			Scorpio: 'Skorpion',
			Sagittarius: 'Schütze',
			Capricorn: 'Steinbock',
			Aquarius: 'Wassermann',
			Pisces: 'Fische',
		},
		kinks: {
			Teasing: 'Necken',
			Praise: 'Lob',
			Roleplay: 'Rollenspiel',
			Dominant: 'Dominant',
			Submissive: 'Unterwürfig',
			Voyeur: 'Voyeur',
			Exhibitionist: 'Exhibitionistin',
			'Slow burn': 'Langsamer Aufbau',
		},
		voice: {
			'Voice 1': 'Stimme 1',
			'Voice 2': 'Stimme 2',
			'Voice 3': 'Stimme 3',
			'Voice 4': 'Stimme 4',
			'Voice 5': 'Stimme 5',
			'Voice 6': 'Stimme 6',
		},
	},
	[LANG_OPTIONS.czech]: {
		personality: {
			Vanilla: 'Vanilková',
			Partying: 'Párty',
			Toxic: 'Toxická',
			Guardian: 'Ochránkyně',
			Noble: 'Ušlechtilá',
			Selfish: 'Sobecká',
			Modest: 'Skromná',
			Brave: 'Odvážná',
			Romantic: 'Romantická',
			Sweet: 'Sladká',
			Naughty: 'Nezbedná',
			Mature: 'Zralá',
			Luxury: 'Luxusní',
			Fitness: 'Sportovní',
			Bossy: 'Dominantní',
			Nerdy: 'Šprtka',
		},
		occupation: {
			Student: 'Studentka',
			Dancer: 'Tanečnice',
			Model: 'Modelka',
			Boss: 'Šéfka',
			Bartender: 'Barmanka',
			Engineer: 'Inženýrka',
			Teacher: 'Učitelka',
			'Fitness trainer': 'Fitness trenérka',
			Cook: 'Kuchařka',
			Artist: 'Umělkyně',
			Doctor: 'Lékařka',
			Librarian: 'Knihovnice',
			Spy: 'Špionka',
			'Police officer': 'Policistka',
			Soldier: 'Voják',
			Lawyer: 'Právnička',
			Hairdresser: 'Kadeřnice',
			Singer: 'Zpěvačka',
			Writer: 'Spisovatelka',
			'Flight attendant': 'Letuška',
			Athlete: 'Sportovkyně',
			Scientist: 'Vědkyně',
			Florist: 'Floriátka',
			Photographer: 'Fotografka',
			Designer: 'Designérka',
			Pharmacist: 'Lékárnice',
			Dietitian: 'Dietoložka',
		},
		relationship: {
			Single: 'Singl',
			Unknown: 'Neznámá',
			Neighbor: 'Sousedka',
			Friend: 'Kamarádka',
			Crush: 'Crush',
			Girlfriend: 'Přítelkyně',
			Wife: 'Manželka',
			Complicated: 'Komplikované',
		},
		nationality: {
			American: 'Američanka',
			British: 'Britka',
			Polish: 'Polka',
			French: 'Francouzka',
			Spanish: 'Španělka',
			Italian: 'Italka',
			German: 'Němka',
			Ukrainian: 'Ukrajinka',
			Brazilian: 'Brazilka',
			Mexican: 'Mexičanka',
			Japanese: 'Japonka',
			Korean: 'Korejka',
			Chinese: 'Číňanka',
			Indian: 'Indka',
			Egyptian: 'Egypťanka',
			Turkish: 'Turkyně',
			Australian: 'Australanka',
			Canadian: 'Kanaďanka',
		},
		zodiac: {
			Aries: 'Beran',
			Taurus: 'Býk',
			Gemini: 'Blíženci',
			Cancer: 'Rak',
			Leo: 'Lev',
			Virgo: 'Panna',
			Libra: 'Váhy',
			Scorpio: 'Štír',
			Sagittarius: 'Střelec',
			Capricorn: 'Kozoroh',
			Aquarius: 'Vodnář',
			Pisces: 'Ryby',
		},
		kinks: {
			Teasing: 'Škádlení',
			Praise: 'Chvála',
			Roleplay: 'Roleplay',
			Dominant: 'Dominance',
			Submissive: 'Submise',
			Voyeur: 'Voyeur',
			Exhibitionist: 'Exhibicionismus',
			'Slow burn': 'Pomalé budování',
		},
		voice: {
			'Voice 1': 'Hlas 1',
			'Voice 2': 'Hlas 2',
			'Voice 3': 'Hlas 3',
			'Voice 4': 'Hlas 4',
			'Voice 5': 'Hlas 5',
			'Voice 6': 'Hlas 6',
		},
	},
};
